import React, { MouseEventHandler } from "react";
import InputField from "@components/common/mobile/inputField";
import { StyledChevronDown, StyledCalendarIcon } from "../styles";
import { ERROR_ACCENT } from "@utils/bike/bikeConstants";

interface Props {
  className?: string;
  icon: string;
  iconAlt: string;
  label: string;
  value?: string;
  placeholder: string;
  error?: boolean;
  onClick: MouseEventHandler;
  type?: string;
  onChange?: Function;
  hideCaret?: boolean;
  calendar?: boolean;
  mobilePrefix?: boolean;
  hideIcon?: boolean;
  handleBlur?: any;
  hideKeyboard?: boolean;
  name?: string;
  inputStyles?: React.CSSProperties;
}

export default function BikeFormItem({
  className,
  // icon,
  // iconAlt,
  label,
  value,
  placeholder,
  error,
  onClick,
  type,
  onChange,
  hideCaret,
  calendar,
  mobilePrefix,
  hideIcon,
  handleBlur,
  hideKeyboard,
  name,
  inputStyles: customInputStyles
}: Props) {
  return (
    <div style={{ position: "relative", marginTop: "2rem" }}>
      <InputField
        name={name}
        mobilePrefix={mobilePrefix}
        label={label}
        classname={className}
        placeholder={placeholder}
        value={value}
        errors={{}}
        inputStyles={{
          border: error && `1px solid ${ERROR_ACCENT}`,
          caretColor: hideCaret && "transparent",
          height: "48px",
          color: "#504a6b",
          ...customInputStyles
        }}
        inputContainerStyles={{ marginTop: "0px" }}
        handleClick={onClick}
        handleChange={data => {
          onChange && onChange(data.target.value);
        }}
        type={type}
        handleBlur={handleBlur}
        readOnly={hideKeyboard}
      />
      {!hideIcon &&
        (calendar ? (
          <StyledCalendarIcon onClick={onClick} style={{ cursor: "pointer" }} />
        ) : (
          <StyledChevronDown onClick={onClick} style={{ cursor: "pointer" }} />
        ))}
    </div>
  );
}
